<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Despacho a Clientes</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="380px">
                <Select2 v-model="cliente" :options="clientes" />
              </td>
              <td width="130px">
                <input
                  id="fechainicio"
                  placeholder="Fecha inicio"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="130px">
                <input
                  id="fechafin"
                  placeholder="Fecha final"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  v-on:click="getReporteMovimientos"
                >
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="containter-table" class="containter-table">
        <table
          id="table1"
          width="100%"
          data-turbolinks="false"
          class="display nowrap"
        >
          <thead>
            <tr>
              <th width="100px">Fecha</th>
              <th width="50px">Consecutivos</th>
              <th width="60px" class="text-center">Tipo</th>
              <th width="60px" class="text-center">Nit</th>
              <th>Cliente</th>
              <th width="60px" class="text-center">Placa</th>
              <th width="60px" class="text-center">Kilometraje</th>
              <th width="60px" class="text-center">Cantidad</th>
              <th width="60px" class="text-center">Precio</th>
              <th width="80px" class="text-center">Venta</th>
              <th width="30px" class="text-center">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
      <div>
        <table width="300px" class="table font-oswald">
          <tbody>
            <tr>
              <td class="subtable" width="150px">TRANSACCIONES</td>
              <td class="subtable b text-right">
                {{ totalventas }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL CANTIDAD</td>
              <td class="subtable b text-right">
                {{ fcantidad }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL IMPUESTOS</td>
              <td class="subtable b text-right">
                {{ ftotalimpuestos }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL VENTAS</td>
              <td class="subtable b text-right">
                {{ ftotales }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <div v-if="despacho_contenedor">
        <div class="bg-gray">
          <div class="despacho margin-auto">
            <div
              class="text-center color-primary"
              style="
                font-size: 18px;
                padding-bottom: 10px;
                font-family: 'Arial Narrow', Helvetica, sans-serif;
                "
            >
              DESPACHOS A FACTURACIÓN ELECTRÓNICA
            </div>
            <table width="100%" class="text-bold" style="font-size: 14px">
              <tbody>
                <tr>
                  <td width="120px" style="background-color: #cccccc">
                    CLIENTE
                  </td>
                  <td
                    style="border-bottom: 1px solid #cccccc; padding-left: 5px"
                  >
                    {{ despacho_tercero_nombre }}
                  </td>
                </tr>
                <tr>
                  <td style="background-color: #cccccc">NIT</td>
                  <td
                    style="border-bottom: 1px solid #cccccc; padding-left: 5px"
                  >
                    {{ despacho_tercero_nit }}
                  </td>
                </tr>
                <tr>
                  <td style="background-color: #cccccc">
                    <i class="fa-regular fa-envelope"></i> CORREO
                  </td>
                  <td
                    style="border-bottom: 1px solid #cccccc; padding-left: 5px"
                  >
                    {{ despacho_tercero_correo }}
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <table class="table table-striped" width="100%">
              <tbody>
                <tr>
                  <th width="50px" class="text-bold">ITEM</th>
                  <th width="70px" class="text-bold">CONS.</th>
                  <th width="50px" class="text-bold">PLACA</th>
                  <th class="text-bold">FECHA</th>
                  <th width="80px" class="text-bold text-right">CANTIDAD</th>
                  <th width="80px" class="text-bold text-right">VALOR</th>
                </tr>
                <tr v-for="item in despachos" :key="item._id">
                  <td>{{ item._id }}</td>
                  <td>{{ item.consecutivo }}</td>
                  <td>{{ item.placa }}</td>
                  <td>{{ item.fecha }}</td>
                  <td class="text-right">{{ item.cantidad }}</td>
                  <td class="text-right">
                    {{ GLOBAL.FORMATO_MONEY_BASIC(item.venta_subtotal) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <table width="100%" class="text-bold" style="font-size: 14px">
                <tbody>
                  <tr>
                    <td class="text-right">TOTAL</td>
                    <td class="text-right" width="100px">
                      {{ GLOBAL.FORMATO_MONEY_BASIC(total_despachos) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-center">
              <hr />
              <div v-if="despacho_tercero_responsabilidad">
                <div v-if="despacho_tercero_correo_valido">
                  <div v-if="despacho_convertir">
                    <button
                      class="btn btn-warning"
                      type="submit"
                      v-on:click="convertirFacturaConciliada"
                    >
                      Convertir
                    </button>
                  </div>
                </div>
                <div v-else class="text-red" style="font-size: 18px">
                  <i class="fa-solid fa-triangle-exclamation"></i> <br />
                  El correo debe ser válido, actualícelo en:<br />
                  <router-link to="/personas/clientes"
                    >Gestión de Clientes</router-link
                  >
                </div>
              </div>
              <div v-else class="text-red" style="font-size: 18px">
                <i class="fa-solid fa-triangle-exclamation"></i> <br />
                El cliente no cuenta con información fiscal, verifique los datos
                en:<br />
                <router-link to="/personas/clientes"
                  >Gestión de Clientes</router-link
                >
              </div>
              <div v-if="despacho_loading">
                <img src="dist/img/kubber-loading.gif" style="width: 30px" />
              </div>
              <div :class="['text-bold', despacho_mensaje_class]">
                {{ despacho_mensaje }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

export default {
  components: { Select2 },
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      clienteService: null,
      clientes: [],
      cliente: "",
      person: null,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totaleds: 0,
      totalimpuestos: 0,
      totales: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      venta: [],
      factura: [],
      loading: true,
      despachos: [],
      total_despachos: 0,
      despacho_contenedor: false,
      despacho_tercero_id: 0,
      despacho_tercero_nombre: "",
      despacho_tercero_nit: "",
      despacho_tercero_correo: "",
      despacho_tercero_correo_valido: false,
      despacho_tercero_responsabilidad: "",
      despacho_convertir: false,
      despacho_loading: false,
      despacho_mensaje: "",
      despacho_mensaje_class: "",
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    console.log(this.person);

    this.reporteService = new ReporteService();
    this.clienteService = new ClienteService();

    this.factura = {};
    this.factura.empresa = {};
    this.factura.consecutivo = {};
    this.factura.origen = {};
    this.factura.invoiceTaxExclusiveTotal = 0.0;

    this.reporte = [];
    this.despachos = [];
    this.despacho_tercero_nombre = "";
    this.despacho_tercero_nit = "";
    this.despacho_tercero_id = "";
    this.despacho_tercero_responsabilidad = "";
    this.despacho_tercero_correo_valido = false;
    this.total_despachos = 0;
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : "01") +
        " 00:00"
    );
    $("#fechafin").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 23:59"
    );

    $("input[datatype='fecha']").datetimepicker();
    this.table = $("#containter-table").html();

    //this.getReporteMovimientos();
    this.getListaCliente();
    this.reporte = [];
  },
  methods: {
    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          console.log(data);

          this.clientes = [];
          for (var i in data) {
            this.clientes.push({ id: data[i]._id, text: data[i].nombres });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    getReporteMovimientos() {
      this.reporte = [];
      this.despachos = [];
      this.despacho_tercero_responsabilidad = true;
      this.despacho_convertir = false;
      this.despacho_tercero_nombre = "";
      this.despacho_tercero_nit = "";
      this.despacho_tercero_id = 0;
      this.despacho_tercero_correo = "";
      this.despacho_tercero_correo_valido = true;
      this.total_despachos = 0;

      var fechainicio = $("#fechainicio").val();
      var fechafin = $("#fechafin").val();
      this.loading = true;
      var documentos =
        GLOBAL.DOCUMENTO.DESPACHO_CREDITO +
        "," +
        GLOBAL.DOCUMENTO.DESPACHO_CONTADO;

      console.log(this.cliente);
      this.reporteService
        .getListaMovimientosDespachos(
          this.person,
          fechainicio,
          fechafin,
          documentos,
          this.cliente
        )
        .then((data) => {
          this.totalventas = 0;
          this.totaleds = 0;

          this.totalimpuestos = 0;
          this.totales = 0;

          var eds = [];

          var x = 0;
          for (const i in data) {
            eds[data[i].estacion] = 1;

            this.reporte[x] = [];
            this.reporte[x].hash = data[i].hasp;
            this.reporte[x].prefijo = data[i].prefijo;
            this.reporte[x].numero = data[i].consecutivo;

            this.reporte[x].tipo =
              data[i].documento_id == 29 ? "CREDITO" : "CONTADO";

            this.reporte[x].item = x;
            this.reporte[x]._id = data[i]._id;
            this.reporte[x].estacion = data[i].estacion;
            this.reporte[x].consecutivo = data[i].prefijo + data[i].consecutivo;
            this.reporte[x].uniqueid = data[i].uniqueid;

            this.reporte[x].persona_nombre = data[i].persona_nombre;

            this.reporte[x].tercero_id = data[i].tercero_id;
            this.reporte[x].tercero_nit = data[i].tercero_nit;

            this.reporte[x].tercero_nombre = data[i].tercero_nombre;
            if (this.reporte[x].tercero_nombre.length >= 20) {
              this.reporte[x].tercero_nombre = this.reporte[
                x
              ].tercero_nombre.substring(0, 20);
            }

            this.reporte[x].placa = data[i].placa;
            this.reporte[x].kilometraje = data[i].kilometraje;

            this.reporte[x].cantidad = GLOBAL.FORMATO_NUMBER(data[i].cantidad);
            this.reporte[x].venta_total = data[i].venta_total;
            this.reporte[x].movimiento_id = data[i].movimiento_id;
            this.reporte[x].venta_subtotal = data[i].venta_total;
            this.reporte[x].precio = GLOBAL.FORMATO_MONEY(data[i].precio);
            this.reporte[x].impuesto_total = GLOBAL.FORMATO_MONEY(
              data[i].impuesto_total
            );

            var fecha = data[i].fecha.split(".")[0].replace("T", " ");
            this.reporte[x].fecha = fecha;

            x++;

            this.totalCantidad += data[i].cantidad;
            this.totalimpuestos += data[i].impuesto_total;
            this.totales += data[i].venta_total;
          }

          for (const i in eds) {
            this.totaleds++;
          }

          this.totalventas = x;

          this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
          this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
          this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);
        })
        .then(() => {
          //FIX: en este orden soluciona el problema de datatable repetida//
          try {
            $("#table1").DataTable().destroy();
          } catch (error) {}
          $("#containter-table").html(this.table);

          const boxes = document.querySelectorAll(".btt");
          boxes.forEach((box) => {
            box.remove();
          });

          //END FIX://

          $("#table1").DataTable({
            data: this.reporte,
            columns: [
              { data: "fecha" },
              { data: "consecutivo" },
              { data: "tipo" },
              { data: "tercero_nit", class: "text-right" },
              { data: "tercero_nombre" },
              { data: "placa" },
              { data: "kilometraje" },
              { data: "cantidad", class: "text-right" },
              { data: "precio", class: "text-right" },
              {
                data: null,
                class: "text-right",
                sortable: false,
                render: function (data, type, full, meta) {
                  var value = full.venta_subtotal;
                  return GLOBAL.FORMATO_MONEY_BASIC(value);
                },
              },
              {
                data: null,
                sortable: false,
                render: function (data, type, full, meta) {
                  var buttonID = full.item;
                  if (full.movimiento_id > 0) {
                    return "";
                  } else {
                    return (
                      '<button class="btn btn-sm btn-info" data-id="' +
                      buttonID +
                      '" id="edit"><i class="fa-solid fa-plus"></i></button>'
                    );
                  }
                },
              },
            ],
            dom:
              "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
              "<'row'<'col-sm-12'tr>>" +
              "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
            buttons: [
              {
                extend: "copyHtml5",
                text: '<i class="fa-regular fa-clipboard"></i>',
              },
              {
                extend: "excelHtml5",
                text: '<i class="fa-regular fa-file-excel"></i>',
              },
              {
                extend: "csvHtml5",
                text: '<i class="fa-solid fa-file-csv"></i>',
              },
              {
                extend: "pdfHtml5",
                text: '<i class="fa-regular fa-file-pdf"></i>',
              },
            ],
            responsive: true,
            autoWidth: false,
            lengthMenu: [
              [5, 10, 20, 50, -1],
              [5, 10, 20, 50, "Todos"],
            ],
            language: {
              url: "plugins/Spanish.json",
            },
          });
          this.loading = false;

          var vm = this;
          $("#table1 tbody").off("click");
          $("#table1 tbody").on("click", "#edit", vm, function () {
            if (!vm.$data.despacho_loading) {
              let id = $(this).data("id");
              let _id = vm.$data.reporte[id]._id;

              var existe = false;
              for (var i in vm.$data.despachos) {
                if (vm.$data.despachos[i]._id == vm.$data.reporte[id]._id) {
                  existe = true;
                  break;
                }
              }

              if (!existe) {
                $(this).removeClass("btn-info");
                $(this).addClass("btn-danger");
                $(this).html('<i class="fa-solid fa-close"></i>');
                vm.addMe(id);
              } else {
                $(this).removeClass("btn-danger");
                $(this).addClass("btn-info");
                $(this).html('<i class="fa-solid fa-plus"></i>');
                vm.removeMe(id);
              }
            } else {
              vm.$data.despacho_mensaje_class = "text-red";
              vm.$data.despacho_mensaje =
                "Operación no permitida durante el proceso";
            }
          });
        });
    },

    addMe(item) {
      if (!this.despacho_loading) {
        console.log(this.reporte[item]);
        var json = this.reporte[item];
        this.despachos.push(json);
        this.despachos.sort(this.comparar);

        this.total_despachos = 0;
        for (var i in this.despachos) {
          this.despacho_tercero_id = this.despachos[i].tercero_id;
          this.despacho_tercero_nit = this.despachos[i].tercero_nit;
          this.despacho_tercero_nombre = this.despachos[i].tercero_nombre;
          this.total_despachos += this.despachos[i].venta_total;

          for (var j in this.clientes) {
            if (this.clientes[j].identificacion == this.despacho_tercero_nit) {
              if (this.clientes[j].atributos == null) {
                this.despacho_tercero_responsabilidad = false;
              } else {
                this.despacho_tercero_responsabilidad = true;
              }

              if (this.clientes[j].contactos != null) {
                for (var t in this.clientes[j].contactos) {
                  if (this.clientes[j].contactos[t].tipo == "CORREO") {
                    this.despacho_tercero_correo_valido =
                      GLOBAL.FORMATO_CORREO_VALIDO(
                        this.clientes[j].contactos[t].descripcion
                      );
                    this.despacho_tercero_correo =
                      this.clientes[j].contactos[t].descripcion;
                  }
                }
              }
            }
          }
        }

        this.despacho_contenedor = true;
        if (this.total_despachos > 0) {
          this.despacho_convertir = true;
        } else {
          this.despacho_convertir = false;
        }
      } else {
        this.despacho_mensaje_class = "text-red";
        this.despacho_mensaje = "Operación no permitida durante el proceso";
      }
    },

    removeMe(item) {
      if (!this.despacho_loading) {
        for (var i in this.despachos) {
          if (this.despachos[i]._id == this.reporte[item]._id) {
            this.despachos.splice(i, 1);
            break;
          }
        }

        this.total_despachos = 0;
        for (var i in this.despachos) {
          this.despacho_tercero_nit = this.despachos[i].tercero_nit;
          this.despacho_tercero_nombre = this.despachos[i].tercero_nombre;
          this.total_despachos += this.despachos[i].venta_total;
        }
        this.despacho_contenedor = true;
        if (this.total_despachos > 0) {
          this.despacho_convertir = true;
        } else {
          this.despacho_convertir = false;
        }
      } else {
        this.despacho_mensaje_class = "text-red";
        this.despacho_mensaje = "Operación no permitida durante el proceso";
      }
    },
    comparar(a, b) {
      return a._id - b._id;
    },
    convertirFacturaConciliada() {
      console.log(this.despachos);

      var request = {};
      request.tercero_id = this.despacho_tercero_id;
      request.tercero_nit = this.despacho_tercero_nit;
      request.tercero_nombre = this.despacho_tercero_nombre;
      request.venta_subtotal = this.total_despachos;
      request.impuesto_total = 0;
      request.descuento_total = 0;
      request.venta_total = this.total_despachos;
      request.origen_id = 0; //0=SOFTWARE_ORIGEN

      request.items = [];
      for (var i in this.despachos) {
        var item = {};
        item.despacho_id = this.despachos[i]._id;
        item.despacho_prefijo = this.despachos[i].prefijo;
        item.uniqueid = this.despachos[i].uniqueid;
        item.despacho_numero = this.despachos[i].numero;
        item.despacho_fecha = this.despachos[i].fecha;
        request.items.push(item);
      }
      this.despacho_convertir = false;
      this.despacho_loading = true;
      this.reporteService
        .convertirFacturaConciliada(this.person, request)
        .then((data) => {
          console.log(data);
          if (typeof data != "undefined") {
            if (data.status == 200) {
              this.despacho_mensaje_class = "text-green";
              this.despacho_mensaje = data.data.mensaje;
              this.despachos = [];
            } else {
              this.despacho_mensaje_class = "text-red";
              this.despacho_mensaje = "Proceso no fue realizado";
            }
          } else {
            this.despacho_mensaje_class = "text-red";
            this.despacho_mensaje = "Proceso no fue realizado";
          }
        })
        .then(() => {
          this.despacho_loading = false;
          this.getReporteMovimientos();
        });
    },
  },
};
</script>
